const scrollTo = (callback) => {
  if (window) {
    const url = new window.URL(window.location.href);
    const params = new window.URLSearchParams(url.search.slice(1));
    for (const p of params) {
      if (p[0] === 'scrollTo') {
        const elem = document.getElementById(p[1]);

        const scroll = () => {
          elem.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        };

        if (elem) {
          if (callback) callback(elem);
          scroll();
        }
      }
    }
  }
};

export default scrollTo;
